import { render, staticRenderFns } from "./LayoutsPanel.vue?vue&type=template&id=31542137"
import script from "./LayoutsPanel.vue?vue&type=script&lang=js"
export * from "./LayoutsPanel.vue?vue&type=script&lang=js"
import style0 from "./LayoutsPanel.vue?vue&type=style&index=0&id=31542137&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports